import { StandardTabsV2 } from '@cimplico/components';

type CWTTabsProps = {
    selectedTabIndex: number;
    onTabChange: (idx: number) => void;
};

function CWTTabs({ selectedTabIndex, onTabChange }: CWTTabsProps): JSX.Element {
    return (
        <div className="border-b dark:border-white/[0.07] -mx-8 px-8">
            <StandardTabsV2 name="cwt" onChange={onTabChange} selectedIndex={selectedTabIndex}>
                <StandardTabsV2.Tab label="Fields" />
                <StandardTabsV2.Tab label="Calculations" />
                <StandardTabsV2.Tab label="Custom Functions" />
                <StandardTabsV2.Tab label="Constants" />
                <StandardTabsV2.Tab label="Settings" />
            </StandardTabsV2>
        </div>
    );
}

export default CWTTabs;
